import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = ({ isMenuOpen, setIsMenuOpen }) => {
  return (
    <header className="bg-brand-brown shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/assets/logo-branco.png" 
              alt="Ilê Asé Sòpònnón" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-brand-cream hover:text-brand-gold font-medium transition-colors"
            >
              Início
            </Link>
            <Link
              to="/calendario"
              className="text-brand-cream hover:text-brand-gold font-medium transition-colors"
            >
              Calendário
            </Link>
            <Link
              to="/transparencia"
              className="text-brand-cream hover:text-brand-gold font-medium transition-colors"
            >
              Transparência
            </Link>
            <Link
              to="/sobre"
              className="text-brand-cream hover:text-brand-gold font-medium transition-colors"
            >
              Sobre
            </Link>
            <Link
              to="/associado/login"
              className="text-brand-cream hover:bg-brand-gold hover:text-brand-brown px-6 py-2.5 rounded-lg font-semibold transition-colors"
            >
              Área do Associado
            </Link>
            <Link
              to="/login"
              className="text-brand-cream hover:text-brand-gold font-medium transition-colors"
            >
              Área Administrativa
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-brand-darkBrown"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-brand-cream" />
            ) : (
              <Menu className="h-6 w-6 text-brand-cream" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-brand-darkBrown">
            <div className="flex flex-col space-y-3">
              <Link
                to="/"
                className="text-brand-cream hover:text-brand-gold font-medium py-2 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Início
              </Link>
              <Link
                to="/calendario"
                className="text-brand-cream hover:text-brand-gold font-medium py-2 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Calendário
              </Link>
              <Link
                to="/transparencia"
                className="text-brand-cream hover:text-brand-gold font-medium py-2 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Transparência
              </Link>
              <Link
                to="/sobre"
                className="text-brand-cream hover:text-brand-gold font-medium py-2 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Sobre
              </Link>
              <Link
                to="/associado/login"
                className="text-brand-cream hover:bg-brand-gold hover:text-brand-brown px-4 py-2 rounded-lg font-semibold text-center transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Área do Associado
              </Link>
              <Link
                to="/login"
                className="text-brand-cream hover:text-brand-gold font-medium py-2 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Área Administrativa
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;

